import React from 'react';
import {
  Box, Button, IconButton, Stack, TextField, Tooltip, Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

/**
 * Filter strip above the audience table: search + broadcast + CSV export.
 *
 * Search debouncing happens upstream (parent reloads on `search`
 * change); the icon button is here for users who'd rather hit Enter
 * via click than wait.
 */
export default function AudienceToolbar({
  search, onSearchChange,
  onRefresh, onBroadcast, onExport,
  rowsShown, disabled,
}) {
  return (
    <Stack direction='row' alignItems='center' spacing='8px' flexWrap='wrap' gap='8px'>
      <TextField
        size='small'
        placeholder='Search name or email'
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ maxWidth: 320, flex: '1 1 220px' }}
      />
      <Tooltip title='Search'>
        <IconButton onClick={onRefresh} size='small'>
          <SearchIcon fontSize='small' />
        </IconButton>
      </Tooltip>
      <Box flex='1' />
      <Button size='small' variant='contained' disabled={disabled} onClick={onBroadcast}>
        Email broadcast
      </Button>
      <Button size='small' variant='outlined' disabled={disabled} onClick={onExport}>
        Export CSV
      </Button>
      <Typography variant='caption' color='text.secondary'>
        {rowsShown} shown
      </Typography>
    </Stack>
  );
}
